<evc-menu
  data-testid="apps-menu"
  class="menu menu--applications z-above"
  position="bottom-right">
  @let frame = isIms() ? 'full' : 'ghost';
  @let type = isIms() ? 'primary' : 'neutral';
  @let isLoading = isApplicationsLoading();
  @let apps = applications();

  <evc-button
    trigger
    evcMenuTriggerState
    class="trigger"
    icon="global-menu"
    size="small"
    [frame]="frame"
    [type]="type"
    style="--button-padding: 0.6rem">
  </evc-button>

  <div class="apps-menu">
    <evc-button
      data-testid="apps-menu--home"
      class="apps-menu__home-btn button_full-width"
      icon="home"
      [text]="('menus.applications.links.home' | platformTranslate)()"
      (click)="handleHomeClick()" />

    <div
      class="apps-list"
      [attr.data-loading]="isLoading"
      [attr.data-testid]="'apps-menu--list'">
      <p class="apps-menu__subtitle">
        {{ ('menus.applications.title' | platformTranslate)() }}
      </p>

      <div class="apps-menu__applications">
        @if (isLoading) {
          @for (skeleton of [0, 1, 2, 3]; track skeleton) {
            <div
              class="apps-menu__item apps-menu__item--skeleton"
              aria-hidden="true">
              <evc-skeleton
                variant="lead-visual"
                size="x-large"
                shape="square" />
              <evc-skeleton
                variant="text"
                size="x-large"
                width="60px" />
            </div>
          }
        } @else {
          @for (app of apps; track $index) {
            @let isUnavailable = isComputedWebApp(app) && !app.isAvailable;
            <div
              class="apps-menu__item-wrapper"
              [evcTooltipHover]="
                isUnavailable
                  ? ('menus.applications.links.unavailable' | platformTranslate)()
                  : app.name
              "
              [evcTooltipSize]="isUnavailable ? 'compact' : 'default'"
              [evcTooltipVisible]="isUnavailable ? 'visible' : 'auto'">
              <button
                [attr.data-testid]="`apps-menu--${slugify(app.name)}`"
                class="apps-menu__item"
                [attr.data-name]="app.name"
                [attr.aria-label]="getAppAriaLabel(app)"
                [disabled]="isUnavailable"
                (click)="handleAppClick(app)">
                <div class="apps-menu__app-badge">
                  @if (isComputedWebApp(app)) {
                    <div
                      [innerHTML]="app.iconHtml"
                      class="icon"></div>
                  } @else {
                    <evc-icon
                      size="xl"
                      [imgUrl]="getAppImgPath(app)"></evc-icon>
                  }
                </div>
                <span class="apps-menu__app-name">{{ app.name }}</span>
              </button>
            </div>
          }
        }
      </div>
    </div>
    <evc-button
      data-testid="apps-menu--marketplace"
      class="apps-menu__more-apps-btn button_full-width"
      type="primary"
      size="large"
      icon="add"
      [text]="('menus.applications.links.marketplace' | platformTranslate)()"
      (click)="handleMarketplaceClick()" />
  </div>
</evc-menu>
